import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '../lib/utils';

const TABS = [
  { to: 'overview', label: 'Overview' },
  { to: 'call_history', label: 'Call history' },
  { to: 'call_recordings', label: 'Recordings' },
  { to: 'volume', label: 'Monthly volume' },
  { to: 'user_reports', label: 'User reports' },
  { to: 'queue_statistics', label: 'Queues' },
  { to: 'ring_groups_statistics', label: 'Ring groups' },
  { to: 'quality', label: 'Quality' },
] as const;

export function ReportTabs(): JSX.Element {
  const { search } = useLocation();
  return (
    <nav aria-label="Reports" className="border-b border-ink-200">
      <div className="-mb-px flex gap-1 overflow-x-auto">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={{ pathname: `/reports/${tab.to}`, search }}
            className={tabClass}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

function tabClass({ isActive }: { isActive: boolean }): string {
  return cn(
    'whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition',
    isActive
      ? 'border-brand-600 text-brand-700'
      : 'border-transparent text-ink-600 hover:border-ink-300 hover:text-ink-800',
  );
}
